import { useQuery } from "react-query";

import { getAttachmentMeta } from "../service";
import { AttachmentLike } from "../types";

export const useAttachmentQuery = (attachment?: AttachmentLike | null) => {
  const { data } = useQuery(
    ["attachment", attachment?.systemId],
    async () => {
      if (attachment!.publicUrl) {
        return await Promise.resolve(attachment);
      } else {
        return await getAttachmentMeta({ systemId: attachment!.systemId });
      }
    },
    {
      enabled: Boolean(attachment),
      suspense: false,
    },
  );

  return {
    data,
  };
};
